<template>
  <div class="menu md-elevation-5" @click="$emit('click')">
    <div class="image" :style="imageStyle"></div>
    <div class="name">{{ menu.menuName }}</div>
    <div class="description-panel">
      <div class="long-name">
        {{ menu.menuLongName }}
      </div>
      <!-- htmlについているWheelをキャンセルするため、@wheel.stopを入れています -->
      <div
        class="description"
        @wheel.stop="nop"
        :style="{ maxHeight: `${size - 40}px` }"
      >
        <pre>{{ menu.description }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menu: Object,
    size: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    imageStyle() {
      return {
        backgroundImage: `url(${this.menu.imageUrl})`,
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    },
  },
  methods: {
    nop() {},
  },
}
</script>

<style lang="scss" scoped>
.menu {
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    .image {
      transform: scale(1.1);
    }
  }

  .image {
    background-size: cover;
    background-position: 40% 40%;
    opacity: 1;
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  .name {
    background: linear-gradient(rgba(38, 50, 56, 0.9), transparent);
    color: #fff;
    font-size: var(--font-size-large);
    padding: var(--spacing-small);
    position: absolute;
    top: 0;
    width: 100%;
  }

  .description-panel {
    background: rgba(38, 50, 56, 0.8);
    color: #fff;
    font-size: var(--font-size-normal);
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    transform: translateY(calc(100% - 40px));
    transition: transform 0.1s ease-in-out;

    // 折り返しを有効にする
    pre {
      white-space: pre-wrap;
    }
  }

  .long-name {
    box-sizing: content-box;
    text-align: right;
    height: 40px;
    line-height: 40px;
    padding-left: var(--spacing-medium);
    padding-right: var(--spacing-medium);
  }

  .description {
    border-top: 1px solid var(--color-border);
    height: calc(100% - 40px);
    font-size: var(--font-size-small);
    padding-left: var(--spacing-medium);
    padding-right: var(--spacing-medium);
    overflow-y: auto;
  }

  &:hover {
    outline: 4px solid #40c4ff;
    outline-offset: 4px;

    .image {
      opacity: 0.7;
    }

    .description-panel {
      transform: translateY(0%);
    }
  }
}
</style>
